<template>
    <div>
        <h3 class="mt-3">Sales Channels</h3>

        <form novalidate @changes="eventActivateUpdateFlag('SalesChannels')">
            <div class="row mt-5">
                <div class="col-sm-10 ml-4">
                    <div class="form-group channelOptions">
                        <div class="mb-2 w-100 dark fs-small">
                            <span class="pointer hoverLink" @click="selectAll(true)">All</span> 
                            <span>/</span>
                            <span class="pointer hoverLink" @click="selectAll(false)">None</span>
                        </div>

                        <div class="full mb-3 pRelative mb-3" v-for="salesChannel in sortedSalesChannels">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="">
                                    <div class="d-flex align-items-center">
                                        <checkbox v-model="salesChannel.isActive" @input="salesChannelStateChanged(salesChannel)" class="mt-1">
                                            {{salesChannel.channelName}}
                                        </checkbox>

                                        <div v-if="salesChannel.channelType == 50" class="ml-2">
                                            <v-select :options="agentsChannelOptions" :disabled="!salesChannel.isActive" v-model="selectedAgentsChannelOptions" @input="agentsChannelOptionsChanged($event, salesChannel)"></v-select>
                                        </div>
                                    </div>

                                    <div v-if="salesChannel.channelType == 50 && salesChannel.isActive && selectedAgentsChannelOptions.value != false">
                                        <div class="d-flex flex-column pRelative ml-4" v-if="getSelectedEvent.salesPermissionsAgentsCustom">
                                            <agent-white-list class="mt-2" :allowedList="getSelectedEvent.salesPermissionsAgentsList" :blockedList="getSelectedEvent.salesBlockedAgentList" :startAllSelected="customAgentListSelectAll" @input="agentListChanged"></agent-white-list>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import extendedVSelect from '@/extends/vue-select'
    import AgentWhiteList from '../../../components/inventory/products/components/AgentWhiteList'

    export default {
        mixins: [],
        props: {
            validations: {
                type: Object
            }
        },
        data() {
            return {
                agentsChannelOptions: [
                    {
                        label: 'All Agents',
                        value: false
                    },
                    {
                        label: 'Agent Selection',
                        value: true
                    }
                ],
                selectedAgentsChannelOptions: {
                    label: 'All Agents',
                    value: false
                }
            }
        },
        created() {
            if (this.getSelectedEvent.salesPermissionsAgentsList && this.getSelectedEvent.salesPermissionsAgentsList.length > 0) {
                this.$set(this.getSelectedEvent, 'salesPermissionsAgentsCustom', true);
                this.selectedAgentsChannelOptions = this.agentsChannelOptions[1];
            } else {
                this.$set(this.getSelectedEvent, 'salesPermissionsAgentsCustom', false);
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent'
            ]),
            customAgentListSelectAll() {
                return false;
            },
            sortedSalesChannels() {
                let arrayToSort = this.getSelectedEvent.channelCommissions;

                return arrayToSort.sort((channelA, channelB) => {
                    if(channelA.channelName > channelB.channelName){
                        return 1;
                    } else if (channelA.channelName < channelB.channelName) {
                        return -1;
                    } else {
                        return 0;
                    }
                })
            }
        },
        methods: {
            agentsChannelOptionsChanged($event, salesChannel) {
                this.eventActivateUpdateFlag('SalesChannels');

                this.getSelectedEvent.salesPermissionsAgentsCustom = $event.value;
                
                if ($event.value == false) {
                    this.getSelectedEvent.salesPermissionsAgentsList = [];
                    this.getSelectedEvent.salesBlockedAgentList = [];
                }
            },
            salesChannelStateChanged(salesChannel) {
                this.eventActivateUpdateFlag('SalesChannels');

                if (salesChannel.channelType == 50 && salesChannel.isActive == false) {
                    // Reset Agents Dropbox
                    this.selectedAgentsChannelOptions = this.agentsChannelOptions[0];
                    this.getSelectedEvent.salesPermissionsAgentsCustom = false;

                    // Deselect all salesChannel (Agent selection) when Agents checkbox is uncheck (not active)
                    this.getSelectedEvent.salesPermissionsAgentsList = [];
                    this.getSelectedEvent.salesBlockedAgentList = [];
                }
            },
            agentListChanged(agentList) {
                this.eventActivateUpdateFlag('SalesChannels');

                if (!this.getSelectedEvent) {
                    return false;
                }

                this.$set(this.getSelectedEvent, 'salesPermissionsAgentsList',
                    agentList.filter(agent => {
                        return agent.selected
                    })
                );

                this.$set(this.getSelectedEvent, 'salesBlockedAgentList',
                    agentList.filter(agent => {
                        return !agent.selected
                    })
                );
            },
            selectAll(val) {
              this.sortedSalesChannels.map(saleChannel => {
                  return saleChannel.isActive = val;
              });

              this.eventActivateUpdateFlag('SalesChannels');
            }
        },
        components: {
            vSelect: extendedVSelect,
            AgentWhiteList,
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// areaSalesPermissions.vue?5804c141